import QuestionValue from "./QuestionValue";

export default class QuestionValueBoolean extends QuestionValue {
    constructor(value) {
        super(value);
    }

    toString() {
        return this._value <= 0 ? "False" : "True";
    }
}